import store from "@/store";

export default [
    {
        path: '/prints/choose',
        name: 'choose-product',
        component: () => import(/* webpackChunkName: "choose-product" */ '../views/ChooseProduct.vue'),
        meta: {
            requiresAuth: true
        },
        beforeEnter: (to, from, next) => {
            let picacode = to.query.picacode
            if (picacode) {
                store.commit('prints/SET_PHOTO_CHOOSER_INITIAL_PICACODE', picacode)
            }
            console.log('to.query.picacode', to.query.picacode)
            next()
        }
    },

    {
        path: '/prints/configure/:printItemId?',
        props: true,
        name: 'configure-product',
        component: () => import(/* webpackChunkName: "configure-product" */ '../views/ConfigureProduct.vue'),
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/prints/finish',
        name: 'configuration-finished',
        component: () => import(/* webpackChunkName: "configuration-finished" */ '../views/ConfigurationFinished.vue'),
        meta: {
            requiresAuth: true
        }
    },
]

